import {connect} from 'react-redux'

import PageLayout from '../../containers/Layout/PageLayout.jsx'

const MustBeAdminOrBm = function (Component) {
  let MustBeAdminOrBmComponent = (props) => {
    const {loading, isAdmin, isBusinessManager, ...rest} = props

    if (loading) {
      return null
    }

    if (!isAdmin && !isBusinessManager) {
      return (
        <PageLayout>
          <h2 className="text-center">
            Impossible d'accéder à ce contenu
          </h2>
          <p className="text-center mb-5">
            Vous devez être connecté en tant qu'Admin ou Business Manager pour pouvoir accéder a cette page.
          </p>
        </PageLayout>
      )
    }

    return <Component {...rest}/>
  }

  return connect(
    state => ({
      loading: state.currentUser?.loading,
      isAdmin: state.currentUser?.user?.isAdmin,
      isBusinessManager: state.currentUser?.user?.isBusinessManager,
    })
  )(MustBeAdminOrBmComponent)
}

export default MustBeAdminOrBm